import { useState, useEffect, ChangeEvent, FormEvent } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import success from "../../../assets/svgs/image 64.svg";
import error from "../../../assets/svgs/image 70.svg";

const API_BASE_URL = "https://api.beatsfussion.com/api";

interface FormData {
  first_name: string;
  last_name: string;
  email: string;
  location: string;
  role: string;
  phone_type: string;
  social_handle: string;
}

const SignupForm = () => {
  const [formData, setFormData] = useState<FormData>({
    first_name: "",
    last_name: "",
    email: "",
    location: "",
    role: "",
    phone_type: "",
    social_handle: "",
  });

  const [showModal, setShowModal] = useState(false);
  const [modalMessage, setModalMessage] = useState("");
  const [modalType, setModalType] = useState<"success" | "error">("success");

  useEffect(() => {
  AOS.init({
    duration: 1000,
    easing: "ease-in-out",
    once: true,
  });
}, []);


  const handleChange = (e: ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e: FormEvent) => {
    e.preventDefault();

    try {
      const res = await fetch(`${API_BASE_URL}/landing-page/create-wait-list/`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(formData),
      });

      if (!res.ok) throw new Error("Something went wrong. Please try again.");

      setModalType("success");
      setModalMessage("🎉 You're on the list! We'll be in touch before the beat drops.");
      setShowModal(true);
      setFormData({
        first_name: "",
        last_name: "",
        email: "",
        location: "",
        role: "",
        phone_type: "",
        social_handle: "",
      });
    } catch (err) {
      setModalType("error");
      setModalMessage("😢 Oops! Something went wrong. Please try again.");
      setShowModal(true);
    }
  };

  return (
    <section
      id="signup"
      className="bg-gradient-to-br from-pink-500 to-purple-600 text-white py-16 sm:py-20 px-4 sm:px-6 md:px-8 text-center"
    >
      <h2 className="text-2xl sm:text-3xl font-bold mb-6" data-aos="fade-down" data-aos-delay="150">Claim Your Spot 🎟️</h2>
      <form
        onSubmit={handleSubmit}
        className="max-w-2xl mx-auto grid grid-cols-1 gap-4 text-left"
        aria-label="Beta signup form"
        data-aos="fade-up"
        data-aos-delay="200"
      >
        <input name="email" type="email" placeholder="Email Address" required className="p-3 rounded-md text-black text-base" value={formData.email} onChange={handleChange} />
        <input name="first_name" type="text" placeholder="First Name" className="p-3 rounded-md text-black text-base" value={formData.first_name} onChange={handleChange} />
        <input name="last_name" type="text" placeholder="Last Name" className="p-3 rounded-md text-black text-base" value={formData.last_name} onChange={handleChange} />
        <input name="location" type="text" placeholder="Where are you based?" className="p-3 rounded-md text-black text-base" value={formData.location} onChange={handleChange} />
        <select name="role" className="p-3 rounded-md text-black text-base cursor-pointer" value={formData.role} onChange={handleChange} required>
          <option disabled value="">What role best describes you?</option>
          <option>Dancer</option>
          <option>Dance Group</option>
          <option>Viewer/Fan</option>
          <option>Other</option>
        </select>
        <select name="phone_type" className="p-3 rounded-md text-black cursor-pointer text-base" value={formData.phone_type} onChange={handleChange} required>
          <option disabled value="">What phone do you use?</option>
          <option>Android</option>
          <option>iPhone</option>
        </select>
        <input name="social_handle" type="text" placeholder="Instagram Handle" className="p-3 rounded-md text-black text-base" value={formData.social_handle} onChange={handleChange} />
        <button
          type="submit"
          className="bg-white text-purple-700 font-bold px-6 py-3 rounded-full shadow-lg hover:bg-gray-100 transition mt-4"
        >
          Let Me In Before the Beat Drops!
        </button>
      </form>

      {showModal && (
        <div className="fixed inset-0 bg-black bg-opacity-40 flex items-center justify-center z-50" data-aos="zoom-in">
          <div className="bg-white text-center rounded-lg p-8 shadow-lg max-w-sm mx-auto">
            <h3 className={`text-lg font-bold mb-3 ${modalType === "success" ? "text-green-600" : "text-red-600"}`}>
              {modalType === "success" ? <img src={success} className="w-14 mx-auto" alt="Success" /> : <img src={error} className="w-14 mx-auto" alt="Error" /> }
            </h3>
            <p className="text-gray-800 mb-4 text-base">{modalMessage}</p>
            <button
              onClick={() => setShowModal(false)}
              className="px-4 py-2 bg-purple-600 text-white text-base rounded-md hover:bg-purple-700 transition"
            >
              Close
            </button>
          </div>
        </div>
      )}
    </section>
  );
};

export default SignupForm;
